module.exports = __webpack_public_path__ + "img/oliver-l.87e4ac2b.jpg";